function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAngleUp = function SvgIconAngleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.21 6.133",
    height: 30,
    width: 33
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.581 6.133a.627.627 0 0 1-.438-.178L5.587 1.508 1.07 5.952a.627.627 0 1 1-.88-.895L5.145.18a.627.627 0 0 1 .879-.002l4.995 4.876a.628.628 0 0 1-.438 1.078Z",
    style: {
      fill: "#393d3c"
    },
    "data-name": "Layer 1"
  }));
};
export default SvgIconAngleUp;